import isEmpty from "lodash/isEmpty";
import cloneDeep from "lodash/cloneDeep";
import store from "../configureStore";
import { getPaginatedArchiveMessages } from "../../services/bot/conversation/ReceivePaginationMessages";
import {
    downloadBotForSelectedDomainInLFStorage, getDataFromLFStorage, getSelectedConversationFromLF, LFStorageKeys,
    saveDataInLFStorage, storeSelectedConversationInLF
} from "../../services/storage/LFStorage";
import { getCurrentTimestamp } from "../../utils/moment";
import { createConversationId, createIMConversation } from "../../utils/conversationUtils";
import { ConversationServiceClient, parseBytesContent } from "../../services/clients/ConversationServiceClient";
import {
    ADD_NEW_CONVERSATION, ARCHIVED_MESSAGES_RECEIVED, CHANGE_SELECTED_CONVERSATION, CLEAR_ACCEPT_IGNORE_CONTACT,
    CLEAR_BOTCALL_CONTENT,
    CLEAR_CHATWIDGET_NOTIFICATIONS, CLEAR_PRINT_SCREEN_CHECK, CLEAR_SELECTED_CONVERSATION, CLEAR_URL_CONTENT, GET_FAVOURITES, HIDE_CHATWIDGET_NOTIFICATION, NEW_SERVER_MESSAGE_RECEIVED,
    REMOVE_AUTHORIZATION_REQUEST,
    REMOVE_NOTIFICATION,
    REMOVE_TABLE_MESSAGE, RENDER_NOTIFICATION, RESET_CHAT_REDUCER, SELECTED_CONTACT_DATA, SELECTED_GROUP_CHAT, SELECTED_GROUP_CHAT_PARTICIPANTS,
    SET_CHAT_IN_WINDOW, SET_IMESSAGE_CHAT_ACTIVE_AREA, SET_IMESSAGE_CHAT_ACTIVE_AREA_DEATAIL, SET_INITIALIZE_CHAT_IN_WINDOW, SET_ONE_TO_ONE_CHAT, SHOW_NOTIFICATION_POP_UP, STANDDARD_NOTI_MSG, TIME_LINE_RECEIVED, TOGGLE__FAVORITE_CONVERSATION, TRACK_FAVORITE_ACTION_PROGRESS,
    UPDATE_CHATWIDGET_NOTIFICATIONS,
    UPDATE_TIME_LINE
} from "../constants";
import { handleTabStack } from "./tabStack";
import { FRONTM_BOT_ID, IM_BOT } from "../../utils/constants";
import { IntToMessageTypeConstants } from "../../services/bot/capability/Message";
import { parseFavourites } from "../../utils/Helpers";
import { UserServiceClientApi } from "../../services/api/UserApiServices";
import { initializeBotContext } from "../../services/bot/initializeBotContext";
import { MessageTypeConstants } from "../../services/bot/Message";
import { showToast } from "../../components/ui/toaster";
import { toggleConversationFavourite } from "../../services/bot/InteractionsService";
import moment from "moment";
import { SocketApiService } from "../../services/api/SocketApiServices";
import { updateContactList } from "./contacts";
import { fetchAllChannels, fetchSubscribedChannels, updateChannelList } from "./channels";
import { find, groupBy, orderBy, uniqBy } from "lodash";
import webSocketApiService from "../../services/socket/wsApiServices";


export const createConversation = (userId, botId, userDomain, chatItem) => {
    if (!userId || !userDomain) return;

    return async (dispatch) => {

        if ((chatItem?.contact || chatItem?.userId)) {
            const contact = (chatItem.contact || chatItem)|| ''
            // let conversationTimeLine = timeLine.filter((conversation) => {
            //     return (
            //         !conversation.channel &&
            //         conversation.contact &&
            //         conversation.contact.userId === bot.userId
            //     );
            // });

            // if (conversationTimeLine.length !== 0) {
            //     dispatch(changeSelectedConversation(conversationTimeLine[0], true));
            //     dispatch(
            //         setScrollPositionForConversation(false, conversationTimeLine[0])
            //     );
            //     initiateConversation(conversationTimeLine[0]);
            //     return;
            // }

            if (!userId || !contact || !userDomain) {
                console.log("Enable to create new conversation due to something geting undefined ", userId, contact, userDomain)
                return;
            };

            //for im. don't create a conversation in the backend until a message is sent.
            let conversation = createIMConversation(userId, contact, userDomain);
            // not to fetch archived ones for the new conversation
            conversation.archivedMessagesRead = true;
            const oneToOneChat = true
            dispatch({ type: ADD_NEW_CONVERSATION, data: { conversation, oneToOneChat: oneToOneChat } });
            console.log('conversation',conversation,oneToOneChat)
            dispatch(changeSelectedConversation(conversation, true, oneToOneChat));
            return;
        }
        else if (chatItem?.channel) {
            let conversationDetails = cloneDeep(chatItem);

            try {
                await storeSelectedConversationInLF(conversationDetails);
            } catch (error) {
                console.error("Error updating selected conversation:", error);
            }

            if (conversationDetails) {
                const oneToOneChat = true
                conversationDetails.unreadCount = 0
                dispatch({
                    type: CHANGE_SELECTED_CONVERSATION,
                    data: { conversation: conversationDetails, toTop: "", oneToOneChat },
                });
            }

            return;
        }

        try {
            const conversation = await createNewConversation(userId, botId, userDomain);
            if (conversation) {
                dispatch({ type: ADD_NEW_CONVERSATION, data: { conversation, oneToOneChat: false } });
                dispatch(changeSelectedConversation(conversation, true, false));
                // await initiateConversationBot(conversation, botId);
            }
        } catch (error) {
            console.error("Error in createConversation: ", error);
        }
    }
};

export const setUserMessagePoolTimestamp = (timestamp = moment().subtract(24, 'hours').valueOf()) => {
    localStorage.setItem('MSG_POOLING_TIMESTAMP', timestamp);
};

export const createNewConversation = async (userId, botId, userDomain) => {
    if (!userId || !botId) {
        console.log("Enable to create new conversation due to something geting undefined ", userId, botId)
        return;
    };

    const conversationId = createConversationId(userId, botId);
    const now = getCurrentTimestamp();
    return {
        createdOn: now,
        modifiedOn: now,
        conversationId,
        botId,
        createdBy: userId,
        participants: [userId],
        userDomain,
    };
};

export const getUserMessagePoolTimestamp = () => {
    const timestamp = localStorage.getItem('MSG_POOLING_TIMESTAMP');
    if (['null', null, undefined].includes(timestamp)) {
        let now = moment().subtract(2, 'weeks').calendar();
        now = moment(now).valueOf();
        return now;
    }
    return parseInt(timestamp, 10);
};

export const streamChatMessages = (fromNewBotMessage = false) => (dispatch, getState) => {
    if (!isEmpty(getState().user.user) && getState().user.isOnline) {
        // By default startTime is the 2 weeks back from current date
        // else it will be timestamp of last message fetched.

        let startTime = getUserMessagePoolTimestamp();
        SocketApiService.GetPaginatedQueueMessages({ startTime })
            .then(({ data }) => {
                if (!isEmpty(data.queueMessages)) {
                    // Parsing the queue messages as default it in Uinit8Array
                    let parsedQueueMessages = [];
                    let domain = {
                        selectedDomain: store.getState()?.domain.selectedDomain,
                    };
                    let activeConversationId = store?.getState().chats.selectedConversation?.conversationId
                    data.queueMessages.forEach((message) => {
                        let contentType = parseInt(message.contentType);
                        switch (contentType) {
                            case 10002:
                            case 10001:
                            case 10003:
                            case 10007:
                            case 10004:
                            case 10005:
                            case 1001:
                                dispatch(updateContactList(cloneDeep(message)));
                                break;
                            case 11001:
                            case 11002:
                                dispatch(updateChannelList(cloneDeep(message)));
                                break;
                        }
                        parsedQueueMessages = parsedQueueMessages.concat(
                            parseMessages(message)
                        );
                    });

                    // Set startTime timestamp to last messages timestamp + 1
                    if (data.moreMessagesExist) {
                        setUserMessagePoolTimestamp(data.nextStartTime);
                    }

                    // console.log(
                    // 	"%c Received new message:",
                    // 	"color: green;",
                    // 	parsedQueueMessages
                    // );

                    // If the new msg is about being added in a new group, fetch the list of groups.
                    let isGroupUpdate = parsedQueueMessages.some(
                        (msg) =>
                            msg.messageType ===
                            MessageTypeConstants.MESSAGE_TYPE_STD_NOTIFICATION &&
                            msg.message &&
                            msg.message.includes("joined the group")
                    );
                    if (isGroupUpdate) {
                        store.dispatch(getTimeLine());
                        store.dispatch(fetchAllChannels(domain));
                        store.dispatch(fetchSubscribedChannels(domain));
                    }

                    // As we pool for all chats we need to update messages
                    // for each conversation individually
                    let conversationMessages = groupBy(
                        parsedQueueMessages,
                        "conversation"
                    );
                    Object.entries(conversationMessages).forEach(
                        async ([conversationId, messages]) => {
                            let cacheMessages =
                                (await getDataFromLFStorage(
                                    `${LFStorageKeys.MESSAGES}_${conversationId}`
                                )) || [];

                            if (
                                getState().chats.chatLog.get(conversationId) &&
                                getState().chats.chatLog.get(conversationId).length >= 0
                            ) {
                                const userId = getState().user?.user?.userId;
                                if (userId && messages) {
                                    // Update redux
                                    dispatch(
                                        onArchivedMessagesReceived(
                                            conversationId,
                                            messages,
                                            false,
                                            userId
                                        )
                                    );
                                }
                            }
                            // Update cache
                            cacheMessages = cacheMessages.concat(messages);
                            let uniqueMessages = uniqBy(cacheMessages, "messageId");
                            uniqueMessages = orderBy(
                                uniqueMessages,
                                ["createdOn"],
                                ["desc"]
                            );
                            let filteredUniqueMessages = uniqueMessages.filter((msg) => (msg.messageType !== "data" || msg.contentType !== 150));

                            saveDataInLFStorage(
                                `${LFStorageKeys.MESSAGES}_${conversationId}`,
                                filteredUniqueMessages
                            );

                            // Update the unread messages count in timeline
                            let timeLine = cloneDeep(getState().chats.timeLine);
                            let timelineConversation = find(timeLine, {
                                conversationId,
                            });
                            if (timelineConversation) {
                                uniqueMessages.forEach((message) => {
                                    if (
                                        message.createdOn > timelineConversation.modifiedOn &&
                                        !message.isOpened
                                    ) {
                                        if (activeConversationId === conversationId) {
                                            find(timeLine, { conversationId }).unreadCount = 0
                                        } else {
                                            find(timeLine, { conversationId }).unreadCount += 1;
                                        }
                                    }
                                });

                                find(timeLine, {
                                    conversationId,
                                }).modifiedOn = uniqueMessages[0].createdOn;

                                setUserMessagePoolTimestamp(uniqueMessages[0].createdOn + 1);
                                dispatch({
                                    type: UPDATE_TIME_LINE,
                                    data: {
                                        timeLine,
                                    },
                                });
                            }
                        }
                    );

                    // Queue Message is paginated and only send 30 messages at a time.
                    // So we pool again to get the data
                    if (!fromNewBotMessage) {
                        setTimeout(() => {
                            dispatch(streamChatMessages());
                        }, 30000);
                    }
                } else {
                    // Set startTime timestamp
                    setUserMessagePoolTimestamp(startTime);
                    // In case there is no new messages on pooling, then pool again after 10 sec
                    if (!fromNewBotMessage) {
                        setTimeout(() => {
                            dispatch(streamChatMessages());
                        }, 30000);
                    }
                }
            })
            .catch((error) => {
                console.error("ERROR in GetPaginatedQueueMessages", error)
                // When session is expired after 1 hour, we receive status 500 with code 16
                if (error.response?.status === 500 && error.response?.data?.code === 16 && error.response?.data?.details === 'UNAUTHORIZED') {
                    // dispatch(handleLogout())
                    // dispatch(showSessionExpiredModal(true));
                }
            }
            );
    }
};

export const initiateConversation = async (conversation, bot = null) => {
    try {
        if (bot === null) {
            let botList = (await getDataFromLFStorage(conversation?.userDomain)) || [];
            bot = botList.filter((item) => item.botId === conversation.bot.botId)[0];
        }

        if (bot == null) {
            let botList = store.getState().user.botSubscriptions;
            bot = botList.filter((item) => item.botId === conversation.bot.botId)[0];
        }

        if (store.getState()?.user?.isAnonymousUser) {
            setTimeout(async () => {
                if (!bot?.botContent) {
                    const res = await downloadBotForSelectedDomainInLFStorage(conversation?.userDomain, bot);
                    bot = res?.find((bot) => bot.botId === conversation.bot.botId);
                }
            }, 500)
        }

        const initiateConversationBot = async (bot) => {
            let messages =
                (await getDataFromLFStorage(
                    `${LFStorageKeys.MESSAGES}_${conversation.conversationId}`
                )) || [];
            const botContext = await initializeBotContext(bot);
            if (botContext && botContext.botContent) {
                botContext.botContent.init({}, messages, botContext);
                // if (
                // 	botContext.authorisedAccess &&
                // 	botContext.userDetails.softwareMfaEnabled
                // ) {
                // 	console.log("2FA Auth for first time");
                // 	store.dispatch(updateSoftwareMfaStatus("idle"));
                // }
            }
            if (botContext && botContext.botContent) {
                botContext.botContent.open instanceof Function &&
                    botContext.botContent.open({}, messages, botContext);
            }

            if (!isEmpty(messages)) {
                let unreadMessages = [];
                messages.forEach((msg) => {
                    if (!msg.isOpened) {
                        unreadMessages.push({
                            conversation: conversation.conversationId,
                            ...msg,
                        });
                    }
                });
                // only update the messages status for selected conversation
                if (
                    store.getState().chats?.selectedConversation?.conversationId ===
                    conversation?.conversationId
                ) {
                    // const selectedConversation= store.getState().chats?.selectedConversation
                    // store.dispatch(
                    //     updateMessageStatusForUser(selectedConversation, unreadMessages)
                    // );
                }
            } else {
                //    const selectedConversation= store.getState().chats?.selectedConversation
                // store.dispatch(updateMessageStatusForUser(selectedConversation, []));
            }
        };

        if (bot && bot.botId !== "im-bot") {
            if (bot.userId) {
                store.dispatch(removeCardCotent());
                sendMessage(
                    getOutgoingMessageRequest(conversation, "startConversation", {
                        message: "",
                        messageType: MessageTypeConstants.MESSAGE_TYPE_STRING,
                    })
                );
            } else {
                initiateConversationBot(bot);
            }
        } else {
            initiateConversationBot({
                userDomain: store.getState()?.domain.selectedDomain,
                botId: "im-bot",
            });
        }

        if (conversation) {
            store.dispatch(fetchArchivedMessages(conversation));
        }
    } catch (error) {
        console.error(
            "There is some error while initiating the bot. Kindly check the bot",
            error
        );
    }
};

export const offlineIngestMessage = (message, conversationId) => {
    return (dispatch, getState) => {
        const selectedBotDetails = getState().domain.selectedBotDetails;

        dispatch(handleTabStack(conversationId, message));

        dispatch({
            type: NEW_SERVER_MESSAGE_RECEIVED,
            data: {
                conversationId,
                message,
                selectedBotDetails,
            },
        });

        setTimeout(() => {
            store.dispatch({
                type: HIDE_CHATWIDGET_NOTIFICATION,
                data: { id: message.messageId }
            });
        }, 5000);
    };
};

export const updateWindowTitle = (conversation) => {
    if (conversation && conversation.bot) {
        if (conversation.bot.botId === IM_BOT) {
            if (conversation.channel && conversation.channel.channelName) {
                window.document.title = conversation.channel.channelName;
            } else if (conversation.contact && conversation.contact.userName) {
                window.document.title = conversation.contact.userName;
            }
        } else {
            if (conversation.bot.botName) {
                if (conversation.bot.botName == "OnShip Assistant ") {
                    window.document.title = conversation.bot.botNameSearch;
                } else {
                    window.document.title = conversation.bot.botName;
                }
            }
        }
    }
};

export const changeSelectedConversation = (conversation, moveToTop, oneToOneChat) => {
    return async (dispatch) => {
        let conversationDetails = cloneDeep(conversation);
        if (conversationDetails && conversationDetails.bot) {
            let botList = (await getDataFromLFStorage(conversationDetails?.userDomain)) || [];
            let bot = botList.filter((item) => item.botId === conversationDetails.bot.botId)[0];
            conversationDetails.bot = {
                ...conversationDetails.bot,
                ...bot,
            };
        };

        if (window.location.pathname.includes('chats')) {
            updateWindowTitle(conversationDetails);
        }

        try {
            await storeSelectedConversationInLF(conversationDetails);
        } catch (error) {
            console.error("Error updating selected conversation:", error);
        }

        if (conversationDetails) {
            conversationDetails.unreadCount = 0
            dispatch({
                type: CHANGE_SELECTED_CONVERSATION,
                data: { conversation: conversationDetails, toTop: moveToTop, oneToOneChat },
            });
        }
    };
};

export const changeConversation =
    (conversation, moveToTop) => (dispatch, getState) => {
        let chats = getState().chats;
        if (
            conversation &&
            chats.selectedConversation &&
            chats.selectedConversation.conversationId === conversation.conversationId
        ) {
            return;
        }
        dispatch(changeSelectedConversation(conversation, moveToTop));
        // initiateConversationBot(conversation);
    };

export function fetchArchivedMessages(conversation, createdOn, fetchDirection, chatHistory = false) {
    return async (dispatch, getState) => {
        try {
            if (!isEmpty(conversation)) {
                let messages = (await getDataFromLFStorage(`${LFStorageKeys.MESSAGES}_${conversation.conversationId}`)) || [];
                let moreMessagesExist = false;

                // If online the make api call and override message and store latest msg in LFStorage
                if (getState().user.isOnline) {
                    getPaginatedArchiveMessages(conversation, createdOn, fetchDirection).then(
                        (response) => {
                            messages = response.messages;
                            moreMessagesExist = response.moreMessagesExist;
                            // let usersAssociation = getState().contacts.usersAssociation;

                            // scan the timeline and fill the user details
                            // messages.forEach((ele) => {
                            //     if (
                            //         ele.conversationOwner &&
                            //         usersAssociation &&
                            //         !usersAssociation[ele.conversationOwner.userId]
                            //     ) {
                            //         dispatch({
                            //             type: ADD_NEW_USER_ASSOCIATION,
                            //             data: ele.conversationOwner,
                            //         });
                            //     }
                            // });

                            // FR 561 fix, loads message on single tap to contact
                            // change the condition to load the messages even if chatlog
                            // is there, avoid the slow load problem
                            // if (getState().chats.chatLog.get(conversation.conversationId)?.length >= 0) {
                            //     const userId = getState().user?.user?.userId;
                            //     if (userId && messages) {
                            //         dispatch(
                            //             onArchivedMessagesReceived(
                            //                 conversation.conversationId,
                            //                 messages,
                            //                 moreMessagesExist,
                            //                 userId,
                            //                 chatHistory,
                            //             )
                            //         );
                            //     }
                            // }

                            let filteredUniqueMessages = messages.filter((msg) => (msg.messageType !== "data" || msg.contentType !== 150));
                            saveDataInLFStorage(`${LFStorageKeys.MESSAGES}_${conversation.conversationId}`, filteredUniqueMessages);
                        }
                    );
                }

                if (!isEmpty(conversation)) {
                    let unreadMessages = [];
                    messages.forEach((msg) => {
                        if (!msg.isOpened) {
                            unreadMessages.push({
                                conversation: conversation.conversationId,
                                ...msg,
                            });
                        }
                    });
                    // only update the messages status for selected conversation
                    // if (
                    // 	store?.getState()?.chats?.selectedConversation?.conversationId ===
                    // 	conversation.conversationId
                    // ) {
                    // 	dispatch(updateMessageStatusForUser(conversation, unreadMessages));
                    // }
                }
                // else {
                //     dispatch(updateMessageStatusForUser(conversation, []));
                // }
                const userId = getState().user?.user?.userId;
                if (userId && messages) {
                    dispatch(
                        onArchivedMessagesReceived(
                            conversation.conversationId,
                            messages,
                            moreMessagesExist,
                            userId
                        )
                    );
                }
            }
        } catch (error) {
            console.error("Error in fetching Archived Messages: ", error);
        }
    };
};

export const createChatBotConversation = (bot, userId) => {
    return async (dispatch, getState) => {
        if (!bot || !userId) {
            return;
        }

        // let { timeLine } = getState().chats;

        // const conversationTimeLine = timeLine.filter(
        //     (conversation) =>
        //         (conversation.bot && conversation.bot === bot.botId) ||
        //         (conversation.bot && conversation.bot.botId === bot.botId)
        // );

        // if (conversationTimeLine.length !== 0) {
        //     dispatch(changeSelectedConversation(conversationTimeLine[0], true, false));
        //     // dispatch(handleUnreadCounts(conversationTimeLine[0], OPEN_CONVERSATION))
        //     return conversationTimeLine[0]
        // }
        // else {
        const botId = bot?.assistantBotConfig ? bot?.assistantBotConfig.botId : bot?.botId
        let conversationId = await createConversationId(userId, botId);
        if (conversationId) {
            let conversation = {
                createdOn: new Date().getTime(),
                modifiedOn: new Date().getTime(),
                conversationId,
                bot,
                createdBy: userId,
                participants: [userId],
                userDomain: bot.userDomain,
            };

            dispatch({ type: ADD_NEW_CONVERSATION, data: { conversation, oneToOneChat: false } });
            dispatch(changeSelectedConversation(conversation, true, false))
            return conversation
        }
        // }
    };
};

export const onArchivedMessagesReceived = (
    conversationId,
    messages,
    moreMessagesExist,
    userId,
    chatHistory
) => {
    return {
        type: ARCHIVED_MESSAGES_RECEIVED,
        data: {
            conversationId: conversationId,
            messages: messages,
            moreMessagesExist,
            userId,
            chatHistory
        },
    };
};

export function parseMessages(rawMessage) {
    let contents = parseBytesContent(rawMessage.details);
    delete rawMessage.details;
    return contents?.map((content) => {
        let newMessage = { ...rawMessage };
        content.messageType =
            content?.messageType || IntToMessageTypeConstants[rawMessage.contentType];
        content.message = content?.message || content.msg;
        delete content.msg;
        return Object.assign({}, newMessage, content);
    });
};

export const resetChatReducer = () => (dispatch) => {
    dispatch({
        type: RESET_CHAT_REDUCER,
    });
};

export function initiateConversationForLink() {
    return async (dispatch, getState) => {
        let linkData = getState().chats.linkData;
        if (!linkData) {
            return;
        }

        let { type, botId, message, action, extraData } = linkData;
        console.log("GETTING NOTIFICATION EXTRA DATA", extraData);
        if (extraData && !QueueServiceClient.isSocketConnected()) {
            console.error('Socket is not connected.');
            return;
        }
        // dispatch(resetLinkData());
        let conversation =
            type === "b"
                ? getConversationByBotId(getState().chats, botId)
                : getConversationById(getState().chats, botId);
        let botSubscriptions = getState().user.botSubscriptions;

        if (message && action === "send") {
            if (conversation) {
                dispatch(changeSelectedConversation(conversation, true));
                dispatch(setScrollPositionForConversation(false, conversation));
                if (!conversation.archivedMessagesRead) {
                    dispatch(fetchArchivedMessages(conversation));
                }
                if (extraData) {
                    if (extraData?.isChat) {
                        message = {
                            "controlId": extraData?.controlId,
                            "tabId": extraData?.tabId,
                            "parentDocId": extraData?.parentDocId,
                            "action": "quickAction",
                            "isChat": extraData?.isChat,
                            "chatType": extraData?.chatType,
                            "content": {
                                "caseId": extraData?.caseId,
                            },
                            "docId": extraData?.docId,
                            "tz": "Etc/UTC"
                        };
                        dispatch(
                            sendAMessage({
                                message,
                                messageType: MessageTypeConstants.MESSAGE_TYPE_TABLE_RESPONSE,
                            })
                        );
                    } else {
                        message = extraData;
                        dispatch(
                            sendAMessage({
                                message,
                                messageId: extraData?.messageId,
                                messageType: MessageTypeConstants.MESSAGE_TYPE_MENU_RESPONSE,
                            })
                        );
                    }
                }
                return;
            }

            if (type === "b") {
                let botIndex = botSubscriptions.findIndex((bot) => {
                    return botId === bot.botId;
                });
                if (botIndex === -1 && botId !== FRONTM_BOT_ID) {
                    Toast({
                        type: "error",
                        message:
                            "You have not subscribed to the mentioned bot yet. Please subscribe to the bot and open the link again.",
                        autoClose: 10000,
                    });
                    return;
                }

                let bot =
                    botId === FRONTM_BOT_ID ? FRONTM_WEB_BOT : botSubscriptions[botIndex];

                createNewConversation(
                    getState().user.user.userId,
                    bot,
                    "sendMessage",
                    message
                )
                    .then((conversation) => {
                        if (botId === FRONTM_BOT_ID) {
                            conversation.bot.logoUrl = "AuthenticationLogo.png";
                        }

                        // dispatch({ type: ADD_NEW_CONVERSATION, data: { conversation } });
                        dispatch(changeSelectedConversation(conversation, true));
                        dispatch(setScrollPositionForConversation(false, conversation));
                        dispatch({
                            type: NEW_CLIENT_MESSAGE_RECEIVED,
                            data: {
                                conversationId: conversation.conversationId,
                                message: {
                                    type: "string",
                                    message,
                                    user: getState().user.user.userId,
                                    createdOn: Date.now(),
                                    time: dayjs().format("hh:mm a"),
                                    createdBy: "self",
                                },
                            },
                        });
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            } else {
                Notify({
                    type: "error",
                    message: "Mentioned conversation does not exist.",
                    autoClose: 70000,
                });
            }
        } else if (message && action === "read") {
            if (!conversation) {
                Notify({
                    type: "error",
                    message: "Mentioned conversation does not exist.",
                    autoClose: 7000,
                });
                return;
            }
            dispatch(changeSelectedConversation(conversation, true));
            dispatch(setScrollPositionForConversation(false, conversation));
            if (!conversation.archivedMessagesRead) {
                dispatch(fetchArchivedMessages(conversation));
            }
        } else if (!message) {
            if (conversation) {
                dispatch(changeConversation(conversation, true));
                return;
            }
            if (type === "b") {
                let botIndex = botSubscriptions.findIndex((bot) => {
                    return botId === bot.botId;
                });
                if (botIndex === -1 && botId !== FRONTM_BOT_ID) {
                    Notify({
                        type: "error",
                        message:
                            "You have not subscribed to the mentioned bot yet. Please subscribe to the bot and open the link again.",
                        autoClose: 10000,
                    });
                    return;
                }

                let bot =
                    botId === FRONTM_BOT_ID ? FRONTM_WEB_BOT : botSubscriptions[botIndex];

                createNewConversation(getState().user.user.userId, bot)
                    .then((conversation) => {
                        if (botId === FRONTM_BOT_ID) {
                            conversation.bot.logoUrl = "AuthenticationLogo.png";
                        }
                        dispatch({ type: ADD_NEW_CONVERSATION, data: { conversation } });
                        dispatch(changeSelectedConversation(conversation, true));
                        dispatch(setScrollPositionForConversation(false, conversation));
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            } else if (type && (type !== "b" || type !== "c")) {
                conversation = await getSelectedConversation();

                if (!isEmpty(conversation)) {
                    dispatch(changeSelectedConversation(conversation, true));
                    dispatch(setScrollPositionForConversation(false, conversation));
                    initiateConversation(conversation);
                } else {
                    createNewConversation(getState().user.user.userId, {
                        userDomain: store.getState()?.selectedDomain?.userDomain,
                        botId: botId,
                    })
                        .then((conversation) => {
                            dispatch({ type: ADD_NEW_CONVERSATION, data: { conversation } });
                            dispatch(changeSelectedConversation(conversation, true));
                            dispatch(setScrollPositionForConversation(false, conversation));
                            initiateConversation(conversation);
                        })
                        .catch((error) => {
                            console.error("[initiateConversationForLink] error :: ", error);
                        });
                }
            } else {
                showToast({
                    type: "error",
                    message: "Mentioned conversation does not exist.",
                })
            }
        }
    };
}
export const getFavourite = (data) => async (dispatch, getState) => {
    webSocketApiService.GetFavouriteConversations(data).then((response) => {

        let newFav = { ...response };
        const botSubscriptions = store?.getState()?.user?.botSubscriptions;
        const favourites = parseFavourites(response, botSubscriptions);
        dispatch({
            type: GET_FAVOURITES,
            data: { getFavourites: { ...newFav, favourites } },
        });
    });
}
export function addConversationToFavourites(
    conversationId,
    userDomain,
    conversation,
    appType,
    userId
) {
    userId = userId || conversation?.contact?.userId;
    let botId = conversation?.bot?.botId;
    let channel = conversation?.channel;
    store.dispatch({
        type: TRACK_FAVORITE_ACTION_PROGRESS,
        data: { userId, startAction: true },
    });
    return (dispatch, getState) => {
        let selectedDomain = getState()?.domain?.selectedDomain;
        let userDomain = getState()?.domain?.selectedDomain;

        toggleConversationFavourite(
            {
                conversationId,
                userDomain,
                action: "add",
                userId,
                appType,
                botId,
                channel,
                selectedDomain
            }
        )
            .then((res) => {
                if (res?.data?.success) {
                    showToast({ type: "success", message: "Conversation has been marked as favorite." });
                    let dataObj = {
                        selectedDomain: selectedDomain
                    };
                    dispatch(getFavourite(dataObj));
                    dispatch({
                        type: TOGGLE__FAVORITE_CONVERSATION,
                        data: { conversationId, favourite: true },
                    });
                    dispatch({
                        type: TRACK_FAVORITE_ACTION_PROGRESS,
                        data: { userId, startAction: false },
                    });
                }
                else {
                    Toast({
                        type: "error",
                        message: res.message,
                    });
                }
                dispatch(getTimeLine(selectedDomain))
            })
            .catch((error) => {
                store.dispatch({
                    type: TRACK_FAVORITE_ACTION_PROGRESS,
                    data: { userId, startAction: false },
                });
            });
    };
}

export function removeConversationFromFavourites(
    conversationId,
    userDomain,
    noNotify = false,
    userId
) {
    store.dispatch({
        type: TRACK_FAVORITE_ACTION_PROGRESS,
        data: { userId, startAction: true },
    });

    return (dispatch, getState) => {
        let selectedDomain = getState()?.domain?.selectedDomain;
        let userDomainBackup = getState()?.domain?.selectedDomain;
        toggleConversationFavourite({ conversationId, userDomain: (userDomain || userDomainBackup), action: "remove", selectedDomain, userId })
            .then((res) => {
                if (res?.data?.success) {
                    if (!noNotify) {
                        showToast('success', "Conversation has been removed from the list of favorites.");
                    }
                    let dataObj = {
                        selectedDomain: selectedDomain,
                    };

                    dispatch(getFavourite(dataObj));
                    dispatch({
                        type: TOGGLE__FAVORITE_CONVERSATION,
                        data: { conversationId, favourite: false },
                    });
                    dispatch({
                        type: TRACK_FAVORITE_ACTION_PROGRESS,
                        data: { userId, startAction: false },
                    });
                    dispatch(getTimeLine(selectedDomain))
                }
            })

            .catch((error) => {
                dispatch({
                    type: TRACK_FAVORITE_ACTION_PROGRESS,
                    data: { userId, startAction: false },
                });
                dispatch(getTimeLine(selectedDomain))
            });
    };
};

// Generalized function for toggling a conversation's favourite status
export function toggleConversationFavouriteStatus({
    conversationId,
    userDomain,
    botId,
    appType,
    userId,
    action,       // "add" or "remove"
    noNotify = false,
}) {
    // store.dispatch({
    //     type: TRACK_FAVORITE_ACTION_PROGRESS,
    //     data: { userId, startAction: true },
    // });

    return (dispatch, getState) => {
        const selectedDomain = getState()?.domain?.selectedDomain;
        const resolvedUserDomain = userDomain || selectedDomain;
        const state = getState();
        const timeLine = state?.chats?.timeLine || [];

        // If conversationId is not provided but userId is, find it from timeline
        let resolvedConversationId = conversationId;
        if (!resolvedConversationId && userId) {
            const conversation = timeLine.find(
                (conv) =>
                    (conv?.contact?.userId === userId || conv?.userId === userId) &&
                    conv.conversationId
            );
            resolvedConversationId = conversation?.conversationId;
        }

        toggleConversationFavourite({
            conversationId: resolvedConversationId,
            userDomain: resolvedUserDomain,
            action,
            userId,
            appType,
            botId,
            selectedDomain
        }).then((res) => {
            console.log('res',res)
            if (res?.success) {
                if (action === "add") {
                    showToast("success", "Conversation marked as favorite.");
                } else if (!noNotify) {
                    showToast("success", "Conversation removed from favorites.");
                }
                let dataObj = { selectedDomain };

                dispatch(getFavourite(dataObj));
                dispatch(getTimeLine(selectedDomain));
                
                // Immediately update the timeline item's favourite property
                if (resolvedConversationId) {
                    dispatch({
                        type: TOGGLE__FAVORITE_CONVERSATION,
                        data: { 
                            conversationId: resolvedConversationId, 
                            favourite: action === "add" 
                        },
                    });
                }
                // dispatch({
                //     type: TRACK_FAVORITE_ACTION_PROGRESS,
                //     data: { userId, startAction: false },
                // });
            } else if (action === "add") {
                showToast({
                    type: "error",
                    message: res.message,
                });
            }
            dispatch(getTimeLine(selectedDomain));
        })
            .catch((error) => {
                console.error(" Error occured during updating favorites", error)
                // dispatch({
                //     type: TRACK_FAVORITE_ACTION_PROGRESS,
                //     data: { userId, startAction: false },
                // });
                dispatch(getTimeLine(selectedDomain));
            });
    };
}


export const sortByModifiedOn = (list) => {
    list.sort(function (a, b) {
        if (a.modifiedOn < b.modifiedOn) return 1;
        if (a.modifiedOn > b.modifiedOn) return -1;
        return 0;
    });
};

export const getTimeLine =
    (userDomain) =>
        async (dispatch, getState) => {
            try {
                let payload = {
                    selectedDomain: userDomain,
                    userDomain
                }
                let response = await webSocketApiService.GetTimeline(payload);
                 console.log("GET TIMELINE RESPONSE:", response);
                let timeLine = [];
                if (response) {
                    let recants = response?.content ? response?.content.conversations : response?.content ? response?.content.conversations : [];

                    let favorites = response?.content ? response?.content.favourites : response?.content ? response?.content.favourites : [];
                    favorites.forEach((conversation) => {
                        conversation.favourite = true;
                    });
                    timeLine = [].concat(favorites).concat(recants);

                    sortByModifiedOn(timeLine);
                
                let selectedConversation = await getSelectedConversationFromLF();
               
                dispatch({
                    type: TIME_LINE_RECEIVED,
                    data: {
                        timeLine: timeLine,
                        favourites: favorites,
                        userId: getState().user?.user && getState().user?.user?.userId,
                        selectedConversation: selectedConversation
                    },
                });
            }
                let linkData = getState().chats.linkData;
                if (!linkData && !timeLine) {
                    let timeLineEmpty = !timeLine || timeLine.length === 0;
                    if (timeLineEmpty && getConversationByBotId(getState().chats, FRONTM_BOT_ID)) {
                        dispatch(addFrontMAssistantToTimeLine());
                    } else if (!timeLineEmpty) {
                        let conversation = await getSelectedConversationFromLF();
                        if (conversation) {
                            const usersAssociation = getState()?.contacts?.usersAssociation;
                            if (
                                usersAssociation && Object.keys(usersAssociation).length > 0 && usersAssociation[conversation?.contact?.userId] !==
                                conversation?.contact?.userName
                            ) {
                                const contactInfo = {
                                    ...conversation.contact,
                                    userName: usersAssociation[conversation.contact.userId],
                                };
                                conversation = {
                                    ...conversation,
                                    contact: contactInfo,
                                };
                            }
                            dispatch(changeSelectedConversation(conversation, true));
                            initiateConversation(conversation);
                        }
                    } else {

                        const fmTimeLine = getConversationByBotId(
                            getState().chats,
                            FRONTM_BOT_ID
                        );
                        dispatch(changeSelectedConversation(null, true));
                        dispatch(
                            setScrollPositionForConversation(
                                false,
                                fmTimeLine || timeLine[0]
                            )
                        );
                        dispatch(changeConversation(fmTimeLine || timeLine[0]));
                    }

                } else {
                    let botSubscriptions = getState().user.botSubscriptions;
                    if (botSubscriptions?.length > 0) {
                        // dispatch(initiateConversationForLink());
                    }
                }

                return timeLine;

            } catch (err) {
                console.error("error in fetching timeline", err);
                let conversation = await getSelectedConversationFromLF();
                if (conversation) {
                    dispatch(changeSelectedConversation(conversation, true));
                    initiateConversation(conversation);
                }
            }
        };

export const setSelectedGroupChat = (data) => {
    return {
        type: SELECTED_GROUP_CHAT,
        payload: data
    };
};

export const setSelectedGroupChatparticipants = (data) => {
    return {
        type: SELECTED_GROUP_CHAT_PARTICIPANTS,
        payload: data
    };
};

export const setSelectedOnetoOneChat = (data) => {
    return {
        type: SET_ONE_TO_ONE_CHAT,
        payload: data
    };
};

export const setSelectedContactData = (data) => {
    return {
        type: SELECTED_CONTACT_DATA,
        payload: data
    };
};

export const removeTableMessage = () => {
    return {
        type: REMOVE_TABLE_MESSAGE,
    };
};

export const removeAuthorizationRequest = () => {
    return {
        type: REMOVE_AUTHORIZATION_REQUEST,
    };
};

export const clearChatwidgetNotifications = () => {
    return {
        type: CLEAR_CHATWIDGET_NOTIFICATIONS,
    };
};

export const updateChatwidgetNotifications = (data) => {
    return {
        type: UPDATE_CHATWIDGET_NOTIFICATIONS,
        payload: data
    };
};


export const clearContentUrl = () => {
    return {
        type: CLEAR_URL_CONTENT,
    };
};
export const clearBotCallData = () => {
    return {
        type: CLEAR_BOTCALL_CONTENT,
    };
};

export const clearSelectedConversation = () => {
    return {
        type: CLEAR_SELECTED_CONVERSATION,
    };
};

export const clearAcceptIgnoreButtons = () => {
    return { type: CLEAR_ACCEPT_IGNORE_CONTACT };
};

export const clearPrintScreenCheck = () => {
    return {
        type: CLEAR_PRINT_SCREEN_CHECK,
    };
};

export const updateTimeLine = (timeLine) => ({
    type: UPDATE_TIME_LINE,
    data: { timeLine },
});

export const setStanddardNotificationMsg = (msg) => ({
    type: STANDDARD_NOTI_MSG,
    payload: msg,
});

export const removeNotifications =
    (conversationId, messageIds = []) => (dispatch, getState) => {

        const { notificationsMsgArray } = getState().chats;
        console.log('removeNotifications',notificationsMsgArray)
        if (!notificationsMsgArray) return;
        let conversationNotifications = notificationsMsgArray[conversationId] || [];
        console.log('conversationNotifications',conversationNotifications)
        if (!Array.isArray(conversationNotifications)) return;
        const filteredNotifications = conversationNotifications.filter(item => {
            return !messageIds.includes(item?.messageId);
        });
        console.log('filteredNotifications',filteredNotifications)
        dispatch({
            type: REMOVE_NOTIFICATION,
            data: {
                [conversationId]: filteredNotifications,
            },
        });
    };


export const markAsOldNotifications = (conversationId) => (dispatch) => {
	if (
		store.getState().chats.notificationsMsgArray &&
		!_.isEmpty(store.getState().chats.notificationsMsgArray)
	) {
		let NonConversationalData =	store.getState().chats.notificationsMsgArray[conversationId];

		if (NonConversationalData && !_.isEmpty(NonConversationalData)) {
			NonConversationalData = NonConversationalData.map((item, i) => {
				return { ...item, markAsOld: true };
			});
		}

		dispatch({
			type: RENDER_NOTIFICATION,
			data: {
				[conversationId]: NonConversationalData,
			},
		});
	}
};

export const setShowNotificationPopUp = (status) => {
    return {
        type: SHOW_NOTIFICATION_POP_UP,
        payload: status
    };
};


export const setShowChatInWindow = (status, message) => {
    return {
        type: SET_CHAT_IN_WINDOW,
        payload: { status, message }
    };
};

export const setInitializeChatInWindow = (data) => {
    return {
        type: SET_INITIALIZE_CHAT_IN_WINDOW,
        payload: data
    };
};

export const setActiveMessageChatArea = (data) => {
    return {
        type: SET_IMESSAGE_CHAT_ACTIVE_AREA,
        payload: data
    };
};

export const setActiveMessageChatAreaDetail = (data) => {
    return {
        type: SET_IMESSAGE_CHAT_ACTIVE_AREA_DEATAIL,
        payload: data
    };
};